import * as angular from 'angular';
import * as contentTypesFile from '../ContentTypes.json';
class ResourceCardController {
    static $inject = ['ModalService', 'TranslateService', '$scope', '$timeout', 'PermissionsService', 'BuilderSegmentService', '$rootScope'];
    constructor(ModalService, TranslateService, $scope, $timeout, PermissionsService, BuilderSegmentService, $rootScope) {
        'ngInject';
        this.BuilderSegmentService = BuilderSegmentService;
        this.$rootScope = $rootScope;
        this.$onInit = () => {
            this.contentTypesSelect = this.loadContentTypesKeyValue();
            this.data.content = this.contentStringfied();
        };
        this.onChangeEditingItemKey = (event) => {
            this.editingItem.key = event.detail?.value;
        };
        this.onChangeEditingItemType = (event) => {
            this.editingItem.type = event.detail?.value;
        };
        this.onChangeEditingItemContent = (event) => {
            this.editingItem.content = event.detail?.value;
            this.error = false;
            if (this.isJson()) {
                try {
                    JSON.parse(this.editingItem.content);
                }
                catch (e) {
                    this.error = true;
                }
            }
        };
        /* Can be: 'initial' or 'editing' */
        this.STATE = 'initial';
        this._application = this.$rootScope.application;
        this.contentTypes =
            contentTypesFile[TranslateService.getCurrentLanguage()];
        this.hasWritePermissions = PermissionsService.hasPermissions('write');
    }
    get typeName() {
        if (!this.data) {
            return;
        }
        const contentType = this.contentTypes.find((i) => i.type == this.data.type);
        if (contentType) {
            return contentType.name;
        }
        return this.data.type;
    }
    get parsedContent() {
        let parsedContent = '';
        if (typeof this.data.content != 'string') {
            parsedContent = JSON.stringify(this.data.content);
        }
        else {
            parsedContent = this.data.content;
        }
        if (parsedContent && parsedContent.length > 150) {
            return `${parsedContent.substring(0, 147)}...`;
        }
        else {
            return parsedContent;
        }
    }
    isJson() {
        return this.editingItem && this.editingItem.type.endsWith('json');
    }
    contentStringfied() {
        if (typeof this.data.content == 'string') {
            return this.data.content;
        }
        else {
            return JSON.stringify(this.data.content);
        }
    }
    loadContentTypesKeyValue() {
        return this.contentTypes.map((type) => ({
            label: type.name,
            value: type.type,
        }));
    }
    convertToString(content) {
        if (!this.isJson() || typeof content == 'string') {
            return decodeURIComponent(content);
        }
        return JSON.stringify(content, undefined, 4);
    }
    convertToObject(content) {
        if (!this.isJson()) {
            return content;
        }
        return JSON.parse(content);
    }
    editItem(item) {
        this.STATE = 'editing';
        this.editingItem = angular.copy(item);
        this.editingItem.content = this.convertToString(this.editingItem.content);
    }
    cancelEdit() {
        this._reset();
    }
    $saveModel() {
        if (!this.editingItem || this.error) {
            return;
        }
        this.data = this.editingItem;
        const { name: resourceName } = this.contentTypes.find(item => item.type === this.data.type);
        if (resourceName) {
            this.BuilderSegmentService.trackEditResource({
                ResourceType: resourceName,
            }, true, this._application);
        }
        this.onSave({ $resource: this.data });
        this._reset();
    }
    $deleteModel() {
        this.onDelete({ $resource: this.data });
        this._reset();
        //get name of type
        const { name: resourceName } = this.contentTypes.find(item => item.type === this.data.type);
        if (resourceName) {
            this.BuilderSegmentService.trackDeleteResource({
                ResourceType: resourceName,
            }, true, this._application);
        }
    }
    _reset() {
        this.STATE = 'initial';
        this.editingItem = undefined;
        this.error = false;
    }
}
ResourceCardController.$inject = ['ModalService', 'TranslateService', '$scope', '$timeout', 'PermissionsService', 'BuilderSegmentService', '$rootScope'];
export default ResourceCardController;
